import { type FormEvent, useState } from 'react';
import { useApi } from '@plataforma/web/api';
import { useSesion } from '@plataforma/web/sesion';

const TIPOS = [
  ['yonke', 'Yonke (desarme y piezas)'],
  ['seminuevos', 'Seminuevos'],
  ['reparador', 'Reparador de siniestrados'],
  ['proveedor', 'Proveedor (taller especialista o refaccionaria)'],
] as const;

/**
 * Quien entró con Google y aún no tiene lotero (arquitectura 2.9): registra el suyo con la misma
 * cuenta o espera la invitación de un dueño.
 */
export function RegistroConCuenta() {
  const api = useApi();
  const { usuario, entrar, salir } = useSesion();
  const [error, setError] = useState<string | null>(null);
  const [enviando, setEnviando] = useState(false);

  const registrar = async (evento: FormEvent<HTMLFormElement>) => {
    evento.preventDefault();
    const datos = new FormData(evento.currentTarget);
    const tipos = datos.getAll('tipos');
    if (!tipos.length) return setError('Elige al menos un tipo de negocio');
    setError(null);
    setEnviando(true);
    try {
      await api('POST', '/platform/registro/con-cuenta', {
        nombre: datos.get('nombre'),
        slug: String(datos.get('slug') ?? '').toLowerCase(),
        tipos,
      });
      // El token nuevo ya trae el lotero y el rol de dueño (la sesión de Keycloak sigue abierta).
      await entrar('/');
    } catch (e) {
      setError((e as Error).message);
      setEnviando(false);
    }
  };

  return (
    <div className="centro">
      <form className="entrada formulario" onSubmit={(e) => void registrar(e)}>
        <h1>Registra tu lotero</h1>
        <p className="subtitulo">
          Entraste como {usuario?.correo}. Si trabajas en un lotero que ya usa Siniestrados, pide a
          su dueño que te invite con este correo. Si es tu negocio, regístralo aquí.
        </p>
        <label className="campo">
          <span>Nombre del negocio</span>
          <input name="nombre" required minLength={2} maxLength={120} />
        </label>
        <label className="campo">
          <span>Subdominio de tu tienda</span>
          <input
            name="slug"
            required
            pattern="[a-z0-9][a-z0-9\-]{1,38}[a-z0-9]"
            title="De 3 a 40 letras minúsculas, números o guiones"
            placeholder="autos-garza"
          />
        </label>
        <fieldset className="campo" style={{ border: 0, padding: 0 }}>
          <span>Tipo de negocio</span>
          {TIPOS.map(([valor, texto]) => (
            <label key={valor} style={{ display: 'flex', gap: 8 }}>
              <input type="checkbox" name="tipos" value={valor} /> {texto}
            </label>
          ))}
        </fieldset>
        {error && <p className="error">{error}</p>}
        <button className="boton primario" disabled={enviando}>
          {enviando ? 'Registrando…' : 'Registrar mi lotero'}
        </button>
        <button type="button" className="boton" onClick={() => void salir()}>
          Salir
        </button>
      </form>
    </div>
  );
}
